<script context="module">
  export type myProfileBlockType = {
    customerName: string;
    title: string;
    url: string;
  };

  export type documentsBlockType = {
    documentsCount: number;
    title: string;
    url: string;
  };
</script>

<script>
  import axios from "axios";

  import { onDestroy } from "svelte/internal";

  import { link, t } from "../../../../core";
  import { loginForQuestionaire } from "../../../../shared/services/questionaire";
  import {
  tryToGetUser,
    userInfo,
    UserInformationType,
  } from "../../../layouts/header/user/user-store";

  export let myProfileBlock: myProfileBlockType;
  export let documentsBlock: documentsBlockType;

  let user: UserInformationType | null;

  onDestroy(
    userInfo.subscribe(info => user = info)
  );

  async function goToQuestionaire() {
    await Promise.all([
      loginForQuestionaire(user!.questionnaireBlock), 
      axios.post("/api/Questionnaire/blockChecked")
    ]);

    tryToGetUser();
  }
</script>

{#if myProfileBlock && documentsBlock}
  <div class="g-centered top-block" class:top-block--3-col={user?.questionnaireBlock && !user?.isImpersonationMode}>
    <a use:link href={documentsBlock.url} class="btn block-link">
      <svg
        class="icon block-link__icon"
        width="36"
        height="42"
        aria-label="documents"
      >
        <use xlink:href="#documents" />
      </svg>
      <div class="block-link__info-block">
        <span class="block-link__header">{documentsBlock?.title}</span>
        <span class="block-link__info"
          >{documentsBlock?.documentsCount}
          {t("HomePage.DocumentsBlock.Count")}</span
        >
      </div>
    </a>

    <a use:link href={myProfileBlock.url} class="btn block-link">
      <svg
        class="icon block-link__icon"
        width="40"
        height="42"
        aria-label="user-icon"
      >
        <use xlink:href="#user-big" />
      </svg>
      <div class="block-link__info-block">
        <span class="block-link__header">{myProfileBlock?.title}</span>
        <span class="block-link__info">{myProfileBlock?.customerName}</span>
      </div>
    </a>

    {#if user?.questionnaireBlock && !user?.isImpersonationMode}
      <a
        href={user.questionnaireBlock.statusUrl}
        class="btn block-link"
        class:block-link--call-to-action={user.questionnaireBlock.showCallToAction}
        on:click|preventDefault={goToQuestionaire}
      >
        <img src="/images/speed-white.svg" width="40" height="40" alt="" />
        <div class="block-link__info-block">
          <span class="block-link__header">{t("QuestionnaireBlock.Title")}</span
          >
          <span class="block-link__info"
            >{t("QuestionnaireBlock.Description")}</span
          >
        </div>
      </a>
    {/if}
  </div>
{/if}

<style lang="scss">
  .top-block {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 40px;
    grid-row-gap: 20px;
    margin-bottom: 50px;

    @include sm-down {
      grid-template-columns: unset;
      margin-bottom: 30px;

      .block-link {
        width: 100%;
      }
    }

    &--3-col {
      grid-template-columns: 1fr 1fr 1fr;
      grid-column-gap: 15px;
      grid-row-gap: 15px;

      @include lg-down {
        grid-template-columns: 1fr 1fr;
      }

      @include sm-down {
        grid-template-columns: unset;
      }

      .block-link {
        padding: 20px;
      }
    }
  }

  .block-link {
    padding: 30px;
    line-height: unset;
    height: unset;

    &--call-to-action {
      position: relative;

      &::before {
        content: "!";
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        font-weight: 900;
        position: absolute;
        top: -11px;
        right: 25px;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        color: $text-reverse-color;
        border: 1px solid currentColor;
        background-color: $warning-color;
      }
    }

    &__info-block {
      display: flex;
      flex-direction: column;
      margin-left: 20px;
    }

    &__header {
      @include h2;
      color: $text-reverse-color;
    }

    &__info {
      @include normal;
      color: $text-reverse-color;
      white-space: normal;
    }
  }
</style>
